module.exports = __webpack_public_path__ + "img/Agradecimientos_Feria_2021.cb96536d.png";